export default function initImageSlider($) {
  
  let selected = 0;
  let debounce = null;

  const $allSliders = $('.image-slider');

  $allSliders.each( function() {

    const $slider = $(this).find('.image-slider-list');

    const selectSlide = (index) => {

      const $slides = $slider.find('.image-slider-slide');
      
      var count = $slides.length;
  
      if (index < 0) {
        index = count - 1;
      }
  
      if (index >= count) {
        index = 0;
      }
  
      selected = index;
  
      $slider.css('transform', 'translateX(' + index * (-100 / count) + '%)');
  
      // This is weird, but get rid of any extraneous pixels on the side of the slides, but make sure that
      // they remain visible during scroll
      $slides.css('visibility', 'visible');
      clearTimeout(debounce);
      debounce = setTimeout(function() {
        $slides.css('visibility', 'hidden');
        $slides.eq(index).css('visibility', 'visible');
      }, 500);
  
      $('.image-slider-dots .image-slider-dot').removeClass('active');
      $('.image-slider-dots .image-slider-dot').eq(index).addClass('active');
    }
  
    // Left and right keys
    $(document).on('keydown', function(e) {
      if (e.keyCode === 37) {
        selectSlide(selected - 1);
      }
  
      if (e.keyCode === 39) {
        selectSlide(selected + 1);
      }
    });
  
    // Swipe
    if ($('.image-slider-main').length > 0) {
      var featured_slide_hammer = new Hammer($('.image-slider-main')[0], {});
      featured_slide_hammer.on('swipeleft', function(ev) {
        selectSlide(selected + 1)
      });
      featured_slide_hammer.on('swiperight', function(ev) {
        selectSlide(selected - 1);
      });
  
      $(document).on('click', '.image-slider-dots .image-slider-dot', function(e) {
        selectSlide($(this).index());
      });
  
      selectSlide(selected);
    }
  
  });
  

}
